// extracted by mini-css-extract-plugin
export default {"button":"channel-link_button__tnncS","channel":"channel-link_channel__+wqBv","link":"channel-link_link__2f2D3","viewAllChannelsButton":"channel-link_viewAllChannelsButton__JQ68t"};